import React, { Component } from "react";
import * as Connection from "./../libs/connections";
import { Link } from "react-router-dom";
import { PropTypes } from "prop-types";

import Preloader from "./global/Preloader";
import CarAvatar from "./CarAvatar";
import SelectInput from "./calculator/SelectInput";

import "../styles/components/SliderOurCars.css";

export default class OurCarAvatars extends Component {
  constructor(props) {
    super(props);

    this.state = {
      typeOfSearch: "samochód",
      activeElement: 0,
      loading: true,
      error: false,
      componentTitle: "",
      elements: []
    };
  }

  getCars = async () => {
    try {
      const response = await Connection.getAllCars(
        null,
        this.state.typeOfSearch === "motocykl" ? 13 : 11
      );
      this.setState({
        elements: response.slice(0, 6),
        loading: false
      });
    } catch (err) {
      this.setState({
        error: true
      });
    }
  };

  async componentDidMount() {
    this.getCars();
  }

  changeTypeOfMachines = (formName = "", selectedValue) => {
    this.setState(
      {
        elements: [],
        typeOfSearch: selectedValue,
        loading: true
      },
      () => {
        this.getCars();
      }
    );
  };

  render() {
    const {
      paddingTop,
      paddingBottom,
      background,
      text,
      sectionNumber
    } = this.props;

    const options = ["samochód", "motocykl"];

    return (
      <div
        className={`our-cars ${background ? "background" : ""}`}
        style={{
          paddingTop: paddingTop + "px",
          paddingBottom: paddingBottom + "px"
        }}
      >
        <div className="our-cars--header container container-small">
          <div className="row">
            <div className="col-12">
              <h5>
                <span>{sectionNumber}</span>
              </h5>
            </div>
            <div className="col-12 col-md-8">
              <h4>{text}</h4>
            </div>
            <div className="col-12 col-md-4 text-right our-cars--buttons">
              <SelectInput
                name="typeOfSearch"
                size="small"
                onChange={this.changeTypeOfMachines}
                selectData={options}
                selected={this.state.typeOfSearch}
                title=""
              />
            </div>
          </div>
        </div>
        <div className="our-cars-avatars container container-small">
          <div className="row">
            {this.state.loading && (
              <div className="col-12">
                <Preloader loading={this.state.loading} />
              </div>
            )}
            {this.state.elements.length > 0 &&
              this.state.elements.map((elem, idx) => {
                if (
                  !(
                    this.props.carId !== undefined &&
                    this.props.carId === elem.id
                  )
                ) {
                  return (
                    <div key={elem.id} className="col-4">
                      <CarAvatar key={idx} carData={elem} />
                    </div>
                  );
                } else {
                  return null;
                }
              })}
          </div>
        </div>
        {
          <div
            className="our-cars--button container container-small"
            style={{ borderBottom: "1px solid #eceef2" }}
          >
            <div className="row">
              <div className="col-12 button--inner">
                <Link
                  className="btn-general btn-general--noBackground"
                  to="/flota"
                >
                  Zobacz wszystkie oferty
                </Link>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

OurCarAvatars.propTypes = {
  paddingTop: PropTypes.number,
  text: PropTypes.string.isRequired,
  paddingBottom: PropTypes.number,
  sectionNumber: PropTypes.string.isRequired,
  carCategory: PropTypes.number,
  carId: PropTypes.number
};

OurCarAvatars.defaultProps = {
  paddingTop: 0,
  paddingBottom: 0
};
